import React from "react";
import { Container, Wrapper, Title } from "./style";

type FDepositProps = {
  children: React.ReactNode;
  title: string;
  leanWrapper?: boolean;
  /** In a dialog the form takes the dialog's own measure, not a page's. */
  $full?: boolean;
};

const FWithdraw = ({ title, children, ...restProps }: FDepositProps) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Wrapper {...restProps}>{children}</Wrapper>
    </Container>
  );
};

export default FWithdraw;
